module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_12_B.abeaa399.mp3";